import { Request } from "express";

import { IParamBinder } from "./IParamBinder";
import { IValueParser } from "./UrlParamBinder";

export class UrlQueryParamBinder implements IParamBinder {
    private readonly name: string;
    private readonly valueParser: IValueParser;

    public constructor(name: string, valueParser: IValueParser) {
        this.name = name;
        this.valueParser = valueParser;
    }

    public extractValue(req: Request): unknown {
        return this.valueParser(req.query[this.name]);
    }
}
